import React, {useState} from "react";
import Button from "@material-ui/core/Button";
//import Button from 'react-bootstrap/Button';
import AurusLogo from "../images/aurus.jpg";

import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

import Checkbox from "@material-ui/core/Checkbox";
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import {useHistory} from "react-router-dom";
import {setUserSession} from "../utils/commons";
import {getApi} from "../App";



const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    //backgroundColor: "#2196f3",

  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));


const INITAL_ERRORS = {
  user: null,
  password: null,
  login: null,
};

export default function Login(props) {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [input, setInput] = useState({user: "", password: ""});
  const [errors, setErrors] = useState(INITAL_ERRORS);
  const [codAbogado, setCodAbogado] = useState("");
  const [abogado, setAbogado] = useState("");
  const history = useHistory();

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const validate = ({user, password}) => {
    let isValid = true;

    let validationErrors = {...INITAL_ERRORS}; // copy errors so that we don't overwrite the default erros
    // Feel free to add more complex validation with Regular Expressions

    if (user.length === 0) {
      validationErrors.user = "Debe completar";
      isValid = false;
    }

    if (password.length < 2) {
      validationErrors.password = "La clave es muy corta ";
      isValid = false;
    }
    setErrors({...validationErrors});

    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const {user, password} = input;

    const isValid = validate({user, password});
    if (!isValid) {
      return;
    }

    getApi()
      .doLogin(user, password)
      .then((data) => {
        setCodAbogado({codAbogado: data.codAbogado});
        setAbogado({abogado: data.razonSocial});
        setUserSession(data.codAbogado, data.razonSocial);

        console.log('Success:', data);
        //alert('Validación de usuario correcta. Bienvenido ' + data.razonSocial);
        //history.push("/");
        props.onSuccess(data);
      })
      .catch((err) => {
        setErrors({...errors, login: err.message});
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <div>
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              Gestión de Gastos Jurídicos
            </Typography>

          </Toolbar>
        </AppBar>

        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="user"
            label="usuario"
            name="user"
            autoComplete="user"
            autoFocus
            value={input.user}
            onChange={(e) => setInput({...input, user: e.target.value})}
            error={!!errors.user}
            helperText={errors.user}
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            name="password"
            label="Contraseña"
            type={showPassword ? "text" : "password"}
            id="password"
            autoComplete="current-password"
            value={input.password}
            onChange={(e) => setInput({...input, password: e.target.value})}
            error={!!errors.password}
            helperText={errors.password}
          />
          <FormControlLabel
            control={
              <Checkbox
                value={showPassword}
                onChange={() => handleShowPassword()}
                color="primary"
              />
            }
            label="Mostrar contraseña"
          />
          <div style={{color: "red"}}>{errors.login}</div>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Ingresar
          </Button>
        </form>
        <div align="center">
          <p>
            <strong>
              <i>Desarrollado por</i>
            </strong>{" "}
            <img
              src={AurusLogo}
              alt={"logo"}
              width="25%"
              height="25%"
              align="middle"
            />
          </p>
        </div>
      </div>
    </Container>
  );
}
